module.exports = __webpack_public_path__ + "assets/img/bcg/bcg_light.png";